import { createPortal } from "react-dom";

const Validations = () => {};

const ufs = [
  { sigla: "AC", nome: "Acre" },
  { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" },
  { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" },
  { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" },
  { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" },
  { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" },
  { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" },
  { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" },
  { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" },
  { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" },
  { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" },
  { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" },
  { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" },
  { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
];

function formataTelefone(phoneNumber, type) {
  if (!phoneNumber) return "";
  const input = String(phoneNumber);
  const digits = input.replace(/\D/g, "");

  // Se ainda não tem os dígitos necessários, não formata para evitar formatar enquanto o usuário digita
  if (type === "C") {
    if (digits.length === 11) {
      return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    return input;
  } else if (type === "F") {
    if (digits.length === 10) {
      return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } 
    return input;
  }

  // fallback: tenta formatar se tiver 10 ou 11 dígitos mesmo sem tipo definido
  if (digits.length === 11) return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  if (digits.length === 10) return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  return input;
}

function stripHtmlTags(text) {
  if (!text) return "";
  return text.replace(/<\/?[^>]+(>|$)/g, "");
}

function truncateText(text, max = 126) {
  if (text == null) return "";
  const str = String(text);
  return str.length > max ? str.slice(0, max) + "..." : str;
}

function formatDocumento(documento, tipo) {
  if (!documento) return "";
  const doc = String(documento || "").replace(/\D/g, "");

  if (tipo === "F") {
    if (doc.length === 11) {
      return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }
    return doc;
  }

  if (tipo === "J") {
    if (doc.length === 14) {
      return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
    return doc;
  }

  return documento;
}

function formataCep(cep) {
  if (!cep) return "";
  const cepLimpo = cep.replace(/\D/g, "");
  return cepLimpo.replace(/(\d{5})(\d{3})/, "$1-$2");
}

export { ufs, Validations, formataTelefone, stripHtmlTags, formatDocumento, formataCep, truncateText };
